export default function asyncLoadScript(src = '', once = true) {
  return new Promise((resolve, reject) => {
    if (once && document.querySelectorAll(`script[src="${src}"]`).length) {
      resolve(true);
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.async = true;
    script.type = 'text/javascript';

    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      reject(`${src} loading failed`);
    };

    document.body.appendChild(script);
  });
}
